import Button from "./Button";
import {useState, useRef, useEffect} from "react";
import {LiaSmsSolid} from "react-icons/lia";

const OTP = ({
                 title,
                 description,
                 verifyOTPLoading,
                 handleRequest,
                 handleVerify,
                 requestOTPLoading,
                 timerCount = 120,
                 showResend=true,
                 error=null
             }) => {

    const [inputValues, setInputValues] = useState(['', '', '', '', '']);
    const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef()];
    const [disabled, setDisabled] = useState(true);
    const [timerDuration, setTimerDuration] = useState(timerCount);
    const [showRequestOTP, setShowRequestOTP] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false)
    const handleRequestOTP = (clicked) => {
        handleRequest()
    }
    const handleVerifyOTP = () => {
        setSubmitLoading(true)
        const OTP = inputValues.join('');
        handleVerify(OTP)


    }
    useEffect(() => {
        handleShowRequestOTP(timerCount)
    }, [])
    useEffect(()=>{
            if(!requestOTPLoading){
                handleShowRequestOTP(timerCount)
            }
    },[requestOTPLoading])
    const handleShowRequestOTP = (time) => {

        if (time) {
            setTimerDuration(time)
        } else {
            setTimerDuration(timerCount)
        }
        setShowRequestOTP(false);
        if (!showRequestOTP) {
            const intervalId = setInterval(() => {
                // Decrement countdown by 1
                setTimerDuration((prevCountdown) => prevCountdown - 1);
            }, 1000); // Update every 1000ms (1 second)

            // Clean up the interval when the component unmounts
            return () => clearInterval(intervalId);
        }

    }
    useEffect(() => {
        if (timerDuration === 0) {
            setShowRequestOTP(true);
        } else {

        }
    }, [timerDuration])

    useEffect(() => {
        if (inputValues.join("").length === inputValues.length) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [inputValues])
    const handleChange = (index, value) => {

        const newInputValues = [...inputValues];
        newInputValues[index] = value;
        setInputValues(newInputValues);
        if (value && index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };
    const handleKeyUp = (e, index) => {
        if (e.code === "Backspace") {
            if (index > 0 && e.target.value === "") {
                inputRefs[index - 1].current.focus()
            }
        }
    }

    return <div className="mt-3  ">

        <div className="w-full  mx-auto   p-3  rounded-lg  bg-white">
            <div className="w-full border-b flex flex-col items-center justify-center  p-5  mb-5 ">
                <div
                    className="p-3 w-16 h-16 bg-green-100 flex flex-col items-center  mb-2 justify-center  rounded-full">
                    <LiaSmsSolid className="text-3xl text-green-700"/>
                </div>
                <h1 className="  text-center  font-bold ">{title}</h1>
                <p className="text-sm  mx-auto w-full text-center ">{description}</p>
            </div>

            <div dir="ltr" className="flex justify-center mt-5   gap-3  items-center">
                {inputValues.map((value, index) => (
                    <div key={index}
                         className={` w-16 border-b border-gray-300  text-lg      flex justify-center items-center ${inputValues[index].length > 0 ? 'bg-gray-100 border-green-300' : 'bg-gray-50'}`}>
                        <input
                            onKeyUp={(e) => handleKeyUp(e, index)}
                            ref={inputRefs[index]}
                            type="tel"
                            maxLength={1}
                            className={"w-full focus:outline-none focus:border-green-500 focus:border  bg-transparent p-5 h-full text-center"}
                            value={value}
                            onChange={(e) => {
                                handleChange(index, e.target.value)
                            }}
                        />
                    </div>
                ))}
            </div>
            <div className="w-full py-2">
                {error && <p className="text-sm text-red-500">{error}</p>}
            </div>
            <div className={`w-full x grid  gap-2 border-t mt-4  pt-5 ${showResend ? "grid-cols-2":"grid-cols-1"}`}>
                {showResend && <Button loading={requestOTPLoading} disabled={!showRequestOTP || submitLoading}
                                       onClick={() => handleRequestOTP(true)}
                                       className="w-full text-sm border"
                                       theme="link"
                                       rounded="rounded-lg">{showRequestOTP ? 'درخواست کد' : ` باقی مانده : ${timerDuration}`}</Button>}

                <Button loading={verifyOTPLoading} onClick={handleVerifyOTP} disabled={disabled || requestOTPLoading}
                        className="w-full text-sm" theme="green"
                        rounded="rounded-lg">مرحله
                    بعد</Button>

            </div>
        </div>
    </div>
}
export default OTP;